import { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Layer, Source } from 'react-map-gl';

export default function ImageLayer({ url, bbox, opacity = 1 }: { url?: string | null; bbox?: number[][] | null; opacity?: number | null }) {
  const sourceId = useMemo(() => uuidv4(), []);
  const layerId = useMemo(() => uuidv4(), []);

  return sourceId && layerId && url && bbox ? (
    <Source id={sourceId} type="image" url={url} coordinates={bbox}>
      <Layer id={layerId} source={sourceId} type="raster" paint={{ 'raster-opacity': opacity || opacity === 0 ? opacity : 1 }} />
    </Source>
  ) : null;
}
